import { render } from "./MultiStepInstanceForm.vue?vue&type=template&id=0008966e"
import script from "./MultiStepInstanceForm.vue?vue&type=script&lang=js"
export * from "./MultiStepInstanceForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__